// extracted by mini-css-extract-plugin
export var slide = "ScreenshotsCarousel-module--slide--9oSn7";
export var slideCaption = "ScreenshotsCarousel-module--slideCaption--q19Bq";